<mat-card class="card experiment-create-details">
    <mat-card-content>
        <div class="name">
            <p class="title">Name</p>
        </div>
        <input matInput class="name" [(ngModel)]="experimentName">
        <div class="description">
            <p class="title">Description</p>
        </div>
        <textarea matInput class="description" [(ngModel)]="experimentDescription"></textarea>
    </mat-card-content>
</mat-card>